import _set from 'lodash/set'
import usersApi from '../../api/users'

export default {
  namespaced: true,

  state: {
    users: {
      loading: false,
      value: []
    }
  },

  actions: {
    async fetchUsers ({ commit }) {
      try {
        commit('SET_USERS', { loading: true })
        const users = await usersApi.getUsers()
        commit('SET_USERS', { value: users })
      } catch (error) {
        console.error('Fetch users failed: ', error)
      }
    }
  },

  mutations: {
    SET_USERS (state, { loading = false, value = [] }) {
      _set(state, 'users', { loading, value })
    }
  }
}
